module.exports = __webpack_public_path__ + "de0038c318c8b1a6d31be1ad7ec490c2.MP3";